import React from 'react';
import 'App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import PrivateRouter from './routers/PrivateRouter';
import Contactus from './pages/Contactus';

// banner
import BannerList from './pages/khajuraho/banners/List';
import AddBanner from './pages/khajuraho/banners/Add';
import UpdateBanner from './pages/khajuraho/banners/Update';

// Khajuraho Packages
import KhajurahoPackageList from './pages/khajuraho/packages/List';
import KhajurahoPackageAdd from './pages/khajuraho/packages/Add';
import KhajurahoPackageUpdate from './pages/khajuraho/packages/Update';

import KhajurahoEnquiryList from './pages/khajuraho/enquiries/List';
import KhajurahoEnquiryUpdate from './pages/khajuraho/enquiries/Update';

// Khajuraho Services
import KhajurahoServiceList from './pages/khajuraho/services/List';
import KhajurahoServiceAdd from './pages/khajuraho/services/Add';
import KhajurahoServiceUpdate from './pages/khajuraho/services/Update';

// Admins
import AdminList from './pages/khajuraho/admins/List';
import AdminAdd from './pages/khajuraho/admins/Add';

// Testimonials
import TestimonialList from './pages/khajuraho/testimonials/List';
import TestimonialAdd from './pages/khajuraho/testimonials/Add';
import TestimonialUpdate from './pages/khajuraho/testimonials/Update';

// Videos
import VideoList from './pages/khajuraho/videos/List';
import VideoAdd from './pages/khajuraho/videos/Add';
import VideoUpdate from './pages/khajuraho/videos/Update';

// Visits
import VisitList from './pages/khajuraho/visit/List';
import VisitAdd from './pages/khajuraho/visit/Add';
import VisitUpdate from './pages/khajuraho/visit/Update';

// Gallery
import GalleryList from './pages/khajuraho/gallery/List';
import GalleryAdd from './pages/khajuraho/gallery/Add';
import GalleryUpdate from './pages/khajuraho/gallery/Update';

// Bookings
import BookingList from './pages/khajuraho/Packeg_booking/List';
import BookingUpdate from './pages/khajuraho/Packeg_booking/Update';

function App() {
  return (
    <Router>
      <Routes>
        {/* Auth Routes */}
        <Route path="/signin" element={<Login />} />
        <Route path="/" element={<Login />} />

        {/* Private Routes */}
        <Route element={<PrivateRouter />}>
          <Route path="/dashboard" element={<Home />} />
          <Route path="/contactus" element={<Contactus />} />

          {/* Banner */}
          <Route path="/khajuraho/banners" element={<BannerList />} />
          <Route path="/khajuraho/banners/add" element={<AddBanner />} />
          <Route path="/khajuraho/banners/update/:id" element={<UpdateBanner />} />

          {/* Packages */}
          <Route path="/khajuraho/packages" element={<KhajurahoPackageList />} />
          <Route path="/khajuraho/packages/add" element={<KhajurahoPackageAdd />} />
          <Route path="/khajuraho/packages/update/:id" element={<KhajurahoPackageUpdate />} />
          
          {/* Enquiries & Services */}
          <Route path="/khajuraho/enquiries" element={<KhajurahoEnquiryList />} />
          <Route path="/khajuraho/enquiries/update/:id" element={<KhajurahoEnquiryUpdate />} />
          <Route path="/khajuraho/services" element={<KhajurahoServiceList />} />
          <Route path="/khajuraho/services/add" element={<KhajurahoServiceAdd />} />
          <Route path="/khajuraho/services/update/:id" element={<KhajurahoServiceUpdate />} />

          {/* Testimonials */}
          <Route path="/khajuraho/testimonials" element={<TestimonialList />} />
          <Route path="/khajuraho/testimonials/add" element={<TestimonialAdd />} />
          <Route path="/khajuraho/testimonials/update/:id" element={<TestimonialUpdate />} />

          {/* Videos */}
          <Route path="/khajuraho/videos" element={<VideoList />} />
          <Route path="/khajuraho/videos/add" element={<VideoAdd />} />
          <Route path="/khajuraho/videos/update/:id" element={<VideoUpdate />} />

          {/* Visits */}
          <Route path="/khajuraho/visits" element={<VisitList />} />
          <Route path="/khajuraho/visits/add" element={<VisitAdd />} />
          <Route path="/khajuraho/visits/update/:id" element={<VisitUpdate />} />

          {/* Gallery */}
          <Route path="/khajuraho/gallery" element={<GalleryList />} />
          <Route path="/khajuraho/gallery/add" element={<GalleryAdd />} />
          <Route path="/khajuraho/gallery/update/:id" element={<GalleryUpdate />} />

          {/* Admins */}
          <Route path="/khajuraho/admins" element={<AdminList />} />
          <Route path="/khajuraho/admins/add" element={<AdminAdd />} />

          {/* Bookings */}
          <Route path="/khajuraho/bookings" element={<BookingList />} />
          <Route path="/khajuraho/bookings/update/:id" element={<BookingUpdate />} />

          {/* Fallback */}
          <Route path="*" element={<h1>No page available</h1>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
